import { render, staticRenderFns } from "./heartlist.vue?vue&type=template&id=40b45742&scoped=true"
import script from "./heartlist.vue?vue&type=script&lang=js"
export * from "./heartlist.vue?vue&type=script&lang=js"
import style0 from "./heartlist.vue?vue&type=style&index=0&id=40b45742&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b45742",
  null
  
)

export default component.exports